import { alpha } from "@material-ui/core";
import { ButtonBase, Stack, Theme, Typography, useTheme } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import CompanyStage from "components/CompanyStage";
import { ROUTES } from "helpers/routes";
import { FC } from "react";
import { Link } from "react-router-dom";
import urlcat from "urlcat";

const Company: FC<{ company: Company; companyCount: number }> = ({
  company,
  companyCount,
}) => {
  const theme: Theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Link
      to={urlcat(ROUTES.COMPANY_DETAILS, {
        slug: company.slug,
      })}
      style={{
        display: "flex",
        flex: "1 0 200px",
        borderRadius: 24,
        overflow: "hidden",
        backgroundColor: "white",
        justifyContent: "center",
        alignItems: "flex-start",
        textDecoration: "none",
        maxWidth: isMobile ? "100%" : 232,
      }}
    >
      <ButtonBase component="div" style={{ width: "100%", padding: 4 }}>
        <Stack direction="column" spacing={1.25} style={{ width: "100%" }}>
          <img
            src={`${process.env.REACT_APP_IMAGE_URL}${company.logo.url}`}
            alt={company.name}
            style={{
              width: "100%",
              height: isMobile ? "auto" : 150,
              maxHeight: isMobile ? 100 : 150,
              objectFit: "contain",
              backgroundColor: alpha(theme.palette.divider, 0.1),
              borderRadius: 24,
              border: `1px solid ${theme.palette.divider}`,
              padding: 12,
            }}
          />
          <Stack spacing={2} direction="row">
            {company?.stage && <CompanyStage stage={company?.stage} />}
          </Stack>
          <Typography
            color="textPrimary"
            variant="h5"
            style={{ fontWeight: 600, marginTop: 16 }}
          >
            {company?.name}
          </Typography>
          <Typography
            variant="body1"
            color="textSecondary"
            style={{ marginTop: 4 }}
          >
            {company?.market}
          </Typography>
        </Stack>
      </ButtonBase>
    </Link>
  );
};

export default Company;
